import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../../context/AppContext";
import { useDailyCheck } from "../../../context/DailyCheckContext";
import { useLogin } from "../../../context/LoginContext";
import localStorageKey from "../../../enumerations/localStorageKey";
import { useGetUserInfo, useLogout } from "../../../hooks/personal/personal.hook";
import { useTikTokPixel } from "../../../hooks/tiktokPixel/tiktokPixel.hooks";
import { copyText } from "../../../plugins/utils";
import activityTypeIdEnum from "../../Event/enumeration/activityTypeIdEnum";
import { useGetPromotionList } from "../../Event/hooks/promotionList.hooks";
import { useGetMessage } from "../../Home/hooks/home.hook";

const PersonalContext = createContext({
  showDailyCheck: false,
  showCode: false,
  setShowLangSelector: () => {},
  isApp: false,
  isRWD: false,
  renderAppVer: () => {},
  logout: () => {},
  isError: false,
  error: undefined,
  data: undefined,
  isLoading: false,
  isHaveNewMessage: false,
  showLangSelector: false,
  navigate: () => {},
  userIconId: undefined,
  handleCopy: () => {},
  openCSDrawer: () => {},
});

export const PersonalContextProvider = ({ children }) => {
  const { t } = useTranslation();
  const { trackEvent, isHaveTikTokPixel } = useTikTokPixel();
  const { openCSDrawer } = useLogin();
  const { mutate: logout } = useLogout();
  const { isApp, isRWD, currentVer } = useApp();
  const [showLangSelector, setShowLangSelector] = useState(false);
  const [isLogin, setIsLogin] = useState();

  const [isHaveNewMessage, setIsHaveNewMesssage] = useState(false);
  const { isLoading, isError, error, data } = useGetUserInfo({});

  const { data: message } = useGetMessage({
    enabled: !!isLogin,
  });

  const { data: promotionList } = useGetPromotionList({
    value: activityTypeIdEnum.ALL,
    page_size: 10,
  });

  const { data: dailyCheckData } = useDailyCheck();

  const [showCode, setShowCode] = useState(false);
  const [showDailyCheck, setShowDailyCheck] = useState(false);

  const renderAppVer = () => {
    const ver = currentVer || localStorage.getItem(localStorageKey.CURRENT_APP_VERSION);
    if (ver) return `APP Ver${ver}`;
    return `APP Ver -`;
  };

  const checkNewMessage = () => {
    if (!message) return;
    const found = message.find((r) => r.read_status === 0);
    if (found) {
      setIsHaveNewMesssage(true);
    } else {
      setIsHaveNewMesssage(false);
    }
  };

  useEffect(() => {
    if (promotionList && promotionList.pages.length > 0) {
      const _showCode =
        promotionList.pages[0].data.find((_data) => _data.promotion_type === "PRCP")?.status ===
          1 || false;
      //ADD DAILY PROMO
      setShowCode(_showCode);
    }
  }, [promotionList]);

  useEffect(() => {
    if (!dailyCheckData) return;
    if (Object.keys(dailyCheckData).length > 0) setShowDailyCheck(true);
  }, [dailyCheckData]);

  useEffect(() => {
    const userIsLogin = Boolean(
      window.localStorage.getItem(localStorageKey.USER_INFO) &&
      window.localStorage.getItem(localStorageKey.TOKEN),
    );

    setIsLogin(userIsLogin);
  }, []);

  useEffect(() => {
    checkNewMessage();
  }, [message]);

  //AccountInfoPersonal Items
  const [userLevel, setUserLevel] = useState("");
  const [userIconId, setUserIconId] = useState();
  const navigate = useNavigate();
  const vipNameProccessor = (levelName) => {
    const num = levelName.replace("VIP", "");
    const final = "V" + num;
    setUserLevel(final);
  };
  const findAvatar = (userId) => {
    const iconId = parseInt(userId) % 20;
    // console.log("iconId", iconId);
    setUserIconId(iconId + 1);
  };
  const handleCopy = (uid) => {
    copyText(uid, t("normal.copy.complete"));
  };

  useEffect(() => {
    if (data?.level_name) {
      vipNameProccessor(data.level_name);
    }
    if (data?.account_id) {
      findAvatar(data.account_id);
    }
  }, [data]);

  useEffect(() => {
    if (isHaveTikTokPixel) {
      trackEvent({
        eventName: "Personal",
      });
    }
  }, [isHaveTikTokPixel, trackEvent]);

  return (
    <PersonalContext.Provider
      value={{
        showDailyCheck,
        showCode,
        setShowLangSelector,
        isApp,
        isRWD,
        renderAppVer,
        logout,
        isError,
        error,
        data,
        isLoading,
        isHaveNewMessage,
        showLangSelector,

        navigate,
        userIconId,
        handleCopy,
        openCSDrawer,
      }}
    >
      {children}
    </PersonalContext.Provider>
  );
};
export const usePersonal = () => {
  const PersonalValue = useContext(PersonalContext);
  return PersonalValue;
};
